const API_URL = process.env.REACT_APP_API_URL_PROD;

const getBooks = async (bookType = "songAudio") => {
    try {
        const token = localStorage.getItem("access_token_esti");
        const etag = localStorage.getItem(`etag_books_${bookType}`);

        const response = await fetch(`${API_URL}/books/?book_type=${bookType}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: token ? `Bearer ${token}` : "",
                "If-None-Match": etag || "",
            },
        });

        if (response.status === 304) {
            console.log("Using cached data (ETag matched).");
            const cachedData = localStorage.getItem(`cached_books_${bookType}`);
            return cachedData ? JSON.parse(cachedData) : null;
        }

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();

        // ETag пен деректерді кэшке сақтау
        const newEtag = response.headers.get("ETag");
        if (newEtag) {
            localStorage.setItem(`etag_books_${bookType}`, newEtag);
            localStorage.setItem(`cached_books_${bookType}`, JSON.stringify(data));
        }

        return data;
    } catch (error) {
        console.error("Failed to fetch books:", error);
        return null;
    }
};

export default getBooks;